export const TabValues = {
  GENERAL_INFO: 'generalInfo',
  AD_ACCOUNT_USERS: 'adAccountUsers',
  REPORTING: 'reporting',
  ADMIN: 'admin',
  REPORT_AVAILABILITY: 'reportAvailability'
};
